export const LINE_WITH_BAR_CONFIG: Highcharts.Options = {
  chart: { type: "column" },
  title: { text: "", align: "left" },
  credits: { enabled: false },
  accessibility: { enabled: false },
  exporting: {
    enabled: true,
    fallbackToExportServer: true,
    sourceWidth: 1400,
    sourceHeight: 600,
    scale: 2,
    buttons: {
      contextButton: {
        align: "right",
        verticalAlign: "top",
        y: -43,
        x: -30,
        menuItems: [
          "viewFullscreen",
          "printChart",
          "downloadPNG",
          "downloadJPEG",
          "downloadCSV",
          "downloadXLS",
          "downloadPDF",
        ],
      },
    },
  },
};
